import MojitoModules from 'mojito/modules';

import {PALETTE_IDS} from '#core/application/modules/ids.js';

import {COLOR, FONT} from '../theme.js';

const SelectionButtonTypes = MojitoModules.SelectionButton.types;
export function getMarketsConfig() {
    const CUSTOM_CONFIG = {
        [PALETTE_IDS.MARKETS]: {
            GameLineMarketContent: {
                selectionNameDisplay: {
                    TOTAL: SelectionButtonTypes.NAME_DISPLAY.SHOW_SHORT,
                },
            },
        },
    };

    const PALETTE = {
        [PALETTE_IDS.MARKETS]: {
            MARKETS_CONTAINER_BG: COLOR.BRAND.BACKGROUND1,
            MARKETS_SHOW_HIDE_ALL_BUTTON_TEXT: {
                color: COLOR.BRAND.FOREGROUND1,
                fontWeight: FONT.WEIGHT_BOLD,
                textTransform: 'capitalize',
                fontSize: FONT.SIZE_MEDIUM,
            },
            MARKET_SELECTION_EACH_WAY_TERMS_LABEL_TEXT: {
                fontSize: '11px',
                color: COLOR.BRAND.FOREGROUND2,
            },
            MARKETS_PRICE_BOOST_ITEM: {
                PBI_SELECTION_NAME_TEXT: {
                    color: COLOR.BRAND.FOREGROUND1,
                    fontWeight: FONT.WEIGHT_BOLD,
                },
                PBI_MARKET_NAME_TEXT: {
                    color: COLOR.BRAND.FOREGROUND2,
                    fontSize: FONT.SIZE_MEDIUM,
                },
            },
            MARKETS_GAME_LINE_PARTICIPANTS: {
                PITCHER_TEXT: COLOR.BRAND.FOREGROUND2,
            },
        },
    };

    return {
        custom: CUSTOM_CONFIG,
        palette: PALETTE,
    };
}
